import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getBusinessInfoRequest, saveBusinessInfoRequest, saveBussinessInfo } from '../apiRequests/companyRequest'
import { getBussinessInfo } from '../apiRequests/companyRequest'



function* handleSaveBusinessInfoRequestHandler(action) {
    try {
        const response = yield call(saveBusinessInfoRequest, action.params)
        yield put({
            type: types.COMPANY_INFO_SAVE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.COMPANY_INFO_SAVE_ERROR,
            error: error.response,
        })
    }
}

function* handleGetBusinessInfoRequestHandler(action) {
    try {
        const response = yield call(getBusinessInfoRequest, action.params)
        yield put({
            type: types.GET_COMPANY_INFO_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_COMPANY_INFO_ERROR,
            error: error.response,
        })
    }
}

function* watcherCompanySaga() {
    yield takeEvery(types.COMPANY_INFO_SAVE_REQUEST, handleSaveBusinessInfoRequestHandler)
    yield takeEvery(types.GET_COMPANY_INFO_REQUEST, handleGetBusinessInfoRequestHandler)
}

export default watcherCompanySaga
